import { render, staticRenderFns } from "./introducer-report-summary.vue?vue&type=template&id=4fdf483f&"
import script from "./introducer-report-summary.vue?vue&type=script&lang=js&"
export * from "./introducer-report-summary.vue?vue&type=script&lang=js&"
import style0 from "./introducer-report-summary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports